module.exports = __webpack_public_path__ + "static/img/forumIndex.1f93d64e.png";